// tslint:disable: only-arrow-functions
// tslint:disable: object-literal-shorthand

import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ActionSheetController, MenuController, Platform } from '@ionic/angular';

import { GlobalConstants } from 'src/app/services/globalConstants/global-constants.service';
import { GlobalFunctionsService } from 'src/app/services/globalFunctions/global-functions.service';

import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { VisitaService } from 'src/app/services/visita/visita.service';

import { SucursalService } from 'src/app/services/sucursal/sucursal.service';
import { ISucursal } from 'src/app/interfaces/ISucursal';

import { DeviceInfoService } from 'src/app/services/deviceInfo/device-info.service';

declare var google;

@Component({
  selector: 'app-sucursal',
  templateUrl: './sucursal.page.html',
  styleUrls: ['./sucursal.page.scss'],
})
export class SucursalPage implements OnInit {

  //#region Propiedades

  @ViewChild('mapa', {static: false}) public mapa;

  public _appVersion: string;

  public _utmCampaign: string = null;
  public _utmContent: string = null;
  public _utmMedium: string = null;
  public _utmSource: string = null;
  public _utmTerm: string = null;

  public _allSucursales: Array<ISucursal> = [];

  public _idZona: string = 'SLW'; // default saltillo
  public _zonaTxt: string = 'SALTILLO'; //

  public _idSucursal: string = '';
  public _sucursal: ISucursal = null;

  //#endregion Propiedades

  //#region Constructor

  constructor(private _route: ActivatedRoute,
              private _platform: Platform,
              private _menuCtrl: MenuController,
              private _deviceInfoSrv: DeviceInfoService,
              private _globalFunctionsSrv: GlobalFunctionsService,
              private _actionSheetCtrl: ActionSheetController,
              private _usuarioSrv: UsuarioService,
              private _visitaSrv: VisitaService,
              private _sucursalSrv: SucursalService) {

    console.log('SucursalPage >> constructor');

  }

  //#endregion Constructor

  //#region Eventos NG

  public ngOnInit() {
    console.log('SucursalPage >> ngOnInit');
    this._menuCtrl.enable(false);
  }

  public async ionViewDidEnter() {
    console.log('SucursalPage >> ionViewDidEnter');

    this._appVersion = GlobalConstants.APP_VERSION;

    // recupera/crea/guarda token publico
    await this._usuarioSrv.doPublicToken();

    // registra visita
    await this._route.queryParams.subscribe((params) => {

      // recupera datos de UTM
      if (params['utm_campaign'] !== undefined) { this._utmCampaign = params['utm_campaign']; }
      if (params['utm_content'] !== undefined) { this._utmContent = params['utm_content']; }
      if (params['utm_medium'] !== undefined) { this._utmMedium = params['utm_medium']; }
      if (params['utm_source'] !== undefined) { this._utmSource = params['utm_source']; }
      if (params['utm_term'] !== undefined) { this._utmTerm = params['utm_term']; }

      this._visitaSrv.guardar('Sucursales', null, null,
      null, null, null, null,
      null, null,
      this._utmCampaign, this._utmContent, this._utmMedium, this._utmSource, this._utmTerm).subscribe();
    });

    this.getAllSucursales('SLW');

    this.getSucursalMasCercana();

  }

  //#endregion Eventos NG

  //#region Eventos Botones

  public async btnZonaClick(idZona: string) {
    this._idSucursal = '';
    this._sucursal = null;

    this.getAllSucursales(idZona);

    // recupera/crea/guarda token publico
    await this._usuarioSrv.doPublicToken();

    // registra visita
    await this._route.queryParams.subscribe((params) => {

      // recupera datos de UTM
      if (params['utm_campaign'] !== undefined) { this._utmCampaign = params['utm_campaign']; }
      if (params['utm_content'] !== undefined) { this._utmContent = params['utm_content']; }
      if (params['utm_medium'] !== undefined) { this._utmMedium = params['utm_medium']; }
      if (params['utm_source'] !== undefined) { this._utmSource = params['utm_source']; }
      if (params['utm_term'] !== undefined) { this._utmTerm = params['utm_term']; }

      this._visitaSrv.guardar('Sucursales', null, null,
      null, null, null, null,
      idZona, null,
      this._utmCampaign, this._utmContent, this._utmMedium, this._utmSource, this._utmTerm).subscribe();
    });
  }

  public async btnSucursalClick(item: ISucursal) {
    this._idSucursal = item.IdSucursal;
    this._sucursal = item;

    this.createMap();

    // recupera/crea/guarda token publico
    await this._usuarioSrv.doPublicToken();

    // registra visita
    await this._route.queryParams.subscribe((params) => {

      // recupera datos de UTM
      if (params['utm_campaign'] !== undefined) { this._utmCampaign = params['utm_campaign']; }
      if (params['utm_content'] !== undefined) { this._utmContent = params['utm_content']; }
      if (params['utm_medium'] !== undefined) { this._utmMedium = params['utm_medium']; }
      if (params['utm_source'] !== undefined) { this._utmSource = params['utm_source']; }
      if (params['utm_term'] !== undefined) { this._utmTerm = params['utm_term']; }

      this._visitaSrv.guardar('Sucursales', null, item.IdSucursal,
      null, null, null, null,
      null, null,
      this._utmCampaign, this._utmContent, this._utmMedium, this._utmSource, this._utmTerm).subscribe();
    });
  }

  public btnFacebookClick() {
    window.open(GlobalConstants.URL_FACEBOOK, '_new');
  }

  public btnInstagramClick() {
    window.open(GlobalConstants.URL_INSTAGRAM, '_new');
  }

  //#endregion

  //#region Otros Metodos

  public getAllSucursales(idZona: string) {

    this._idZona = idZona;

    switch (this._idZona) {
      case 'SLW':
        this._zonaTxt = 'SALTILLO';
        break;
      case 'RA':
        this._zonaTxt = 'RAMOS ARIZPE';
        break;
      case 'ART':
        this._zonaTxt = 'ARTEAGA';
        break;
      case 'MVA':
        this._zonaTxt = 'MONCLOVA';
        break;
      case 'TORR':
        this._zonaTxt = 'TORREON';
        break;
      case 'MTY':
        this._zonaTxt = 'MONTERREY';
        break;
      case 'all':
        this._zonaTxt = 'TODOS';
        break;
      default:
        break;
    }

    this._sucursalSrv.getAllSucursalesByIdZona(idZona).subscribe(() => {
      this._allSucursales = this._sucursalSrv.AllSucursalesPorZona;

      this.createMap();
    });
  }

  public getZonaButtonColor(idZona: string): string {

    if (idZona == this._idZona) {
      return 'blueWhite';
    } else {
      return 'whitePink';
    }
  }

  public getZonaButtonIconStyle(idZona: string): string {
    if (idZona == this._idZona) {
      return 'color: #FFFFFF; font-size: 1.4em; padding-right: 10px;';
    } else {
      return 'color: #E15983; font-size: 1.4em; padding-right: 10px;';
    }
  }

  private createMap() {
    console.log('SucursalPage >> createMapa');

    if (this._allSucursales.length > 0) {

      // pone limites del mapa
      const zonaLat: number = this._allSucursales[0].ZonaLat;
      const zonaLng: number = this._allSucursales[0].ZonaLng;
      let zonaZoom: number = this._allSucursales[0].ZonaZoom;

      if (this._idZona == 'MTY' && this._platform.width() <= 768) {
        zonaZoom = zonaZoom - 1;
      }

      const mapZona = new google.maps.Map(
        this.mapa.nativeElement,
        {
          center: { lat: zonaLat, lng: zonaLng },
          zoom: zonaZoom,
          mapTypeId: 'roadmap',
          mapId: 'dabb516c50051031'
        }
      );

      // pone marcas por sucursal
      this._allSucursales.forEach(item => {

        let icono: string;

        if (item.IdSucursal == this._idSucursal) {
          icono = 'assets/img/inicio.pink.113x113.png';
        } else {
          icono = 'assets/icon/logo.transparente.200x200.png';
        }

        const abuePNG = document.createElement('img');
        abuePNG.src = icono;
        abuePNG.width = 80;
        abuePNG.height = 80;

        const pin = new google.maps.marker.PinElement({
          scale: 1,
          glyph: abuePNG,
      });

        const marker = new google.maps.marker.AdvancedMarkerElement({
          position: {
            lat: item.Lat,
            lng: item.Lng
          },
          map: mapZona,
          content: pin.element,
          // icon: {
          //   url: icono,
          //   scaledSize: new google.maps.Size(40, 40)
          // },
          // animation: google.maps.Animation.DROP,
        });

        const infowindow = new google.maps.InfoWindow({
          content:
            '<table>' +
            '  <tr>' +
            '    <td style="width: 50%">' +
            '      <img src="assets/icon/logo.transparente.200x200.png" style="width: 80px; height: 80px">' +
            '    </td>' +
            '    <td style="width: 50%; font-family: \'Montserrat\'; color: #E15983">' +
            '      Sucursal ' + item.Nombre +
            '    </td>' +
            '  </tr>' +
            '</table>' +
            ' <br/>' +
            '' + item.Domicilio + '<br/>' +
            'Tel: ' + item.Telefono1 + ' ' + item.Telefono2 + '<br/><br/> ' +
            'Horario: <br/>' + item.HorarioTxt + '<br/><br/> ' +
            '<a href="https://www.google.com/maps/dir/?api=1&destination=' + item.Lat + ',' + item.Lng +
              '&travelmode=driving" target="_new">' +
              '<img src="assets/img/indicaciones.primary.24x24.png" style="margin-right: 15px">' +
              '<span>Cómo llegar</span>' +
            '</a>',
          maxWidth: 350
        });

        marker.addListener('click', function() {
          infowindow.open(mapZona, marker);
        });

      });
    }
  }

  public getSucursalMasCercana() {

    // si se pudieron recuperar las coordenadas del usuario
    if (this._deviceInfoSrv.CurrentDeviceInfo.DeviceLat !== null &&
        this._deviceInfoSrv.CurrentDeviceInfo.DeviceLng !== null) {
      // recupera todas las sucursales
      this._sucursalSrv.getAllSucursales().subscribe(() => {

        const allSucursales: Array<ISucursal> = this._sucursalSrv.AllSucursales;

        // recupera coordenadas locales
        const lat: number = this._deviceInfoSrv.CurrentDeviceInfo.DeviceLat;
        const lng: number = this._deviceInfoSrv.CurrentDeviceInfo.DeviceLng;

        let sucursal: ISucursal = null;
        let dist: number = null;

        // recorre sucursales
        allSucursales.forEach(item => {

          if (item.Lat !== null && item.Lat !== undefined && item.Lng !== null && item.Lng !== undefined) { // sucursal tiene coordenadas

            // calcula distancia del dispositivo a la sucursal
            const distToPlace: number = this._globalFunctionsSrv.distanceToPlace(lat, lng, item.Lat, item.Lng, 'K');
            console.info('>> Distancia >> ' + item.Nombre + ' >> ' + distToPlace.toLocaleString('en') );

            // si es la primer distancia, o es distancia menos a las anteriores, se selecciona
            if (dist == null || distToPlace < dist) {
              dist = distToPlace;
              sucursal = item;
            }
          }

        });

        //
        if (sucursal !== null) { // si se encontro sucursal

          // llena sucursales de la zona
          this.getAllSucursales(sucursal.IdZona);
          this.btnSucursalClick(sucursal);

          this._actionSheetCtrl.create({
            header: 'Nuestra sucursal más cercana es:\n' + sucursal.Nombre +
            '\na una distancia de: ' + dist.toLocaleString('en') + ' km',
            animated: true,
            cssClass: 'actionSheetCtrl',
            buttons: [
              {
                text: 'Ok',
                role: 'cancel',
                cssClass: 'secondary',
                }
              ]
          }).then((alert) => {
            alert.present();
          });

        }

      });
    }

  }

  //#endregion
}
